<template>
  <full-screen-container class="report_container">
    <div class="top">
      <div class="left-top">
        <el-card style="min-width: 380px" class="card" :body-style="{padding:'0 10px',height:'610px'}">
          <user-info />
          <user-todo />
        </el-card>
      </div>
    </div>
  </full-screen-container>
</template>
<script>

import UserInfo from '../components/portalBiz/UserInfo'
import UserTodo from '../components/portalBiz/UserTodo'
import FullScreenContainer from '../components/fullScreenContainer'
export default {
  name: 'personalPortal',
  components: {
    UserInfo,
    UserTodo,
    FullScreenContainer
  },
  data () {
    return {
      name: '用户工作台'
    }
  },
  watch: {

  },
  methods: {

  }
}

</script>

<style lang="scss" scoped>
  .report_container{
    background-color: white;
  }
  .top{
    display: flex;
    padding-bottom: 1%;
    min-width: 1236px;
    .left-top {
      width: 30%;
      min-width: 380px;
    }
    .right-top {
      width: 70%;
      padding-left: 10px;
    }
  }
  .bottom{
    display: flex;
    min-width: 1236px;
    .left-bottom {
      width: 30%;
      min-width: 380px
    }
    .middle-bottom {
      width: 40%;
      min-width: 450px
    }
    .right-bottom {
      width: 30%;
      min-width: 406px
    }
  }
  .card {
    width: 100%;
  }

</style>
